// scroll / resize を requestAnimationFrame で次フレームに1回だけ間引く。
// 使い方: window.addEventListener('scroll', rafThrottle(onScroll), { passive: true });
export function rafThrottle(callback) {
  let ticking = false;
  return (...args) => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      callback(...args);
      ticking = false;
    });
  };
}
